module.exports = __webpack_public_path__ + "img/dr-nate-wiechmann-pott-county-sports-family-chiropractic.52b1c1d0.jpg";